/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-28 10:05:55
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 12:28:47
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/components/coupon/index.tsx
 * @Description: 优惠券卡片
 */
import React, { memo, useContext, useMemo } from 'react';
import "./index.scss";
import classnames from 'classnames';
import CouponBtn from "./couponBtn";
import { ThemeContext } from "../BuyModal/context";
// import dataReport from '@utils/data-report';

const CheckType = ({
  disabled,
  onChange,
  checked
}) => {
  const {
    dataReport
  } = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "event-coupon-item-check-zone"
  }, /*#__PURE__*/React.createElement("input", {
    checked: checked,
    onChange: e => {
      // @ts-ignore
      onChange?.(e);
      dataReport('e#event_order_confirm#coupon_chosen_button#click', {
        chosencoupon: checked ? 1 : 0
      });
    },
    disabled: disabled,
    type: "checkbox",
    className: "event-coupon-item-check"
  }));
};
const Coupon = ({
  invalid,
  checkType,
  goToUse,
  onChange,
  className,
  coupon,
  onClick
}) => {
  const priceSize = useMemo(() => {
    const price = coupon?.coupon_value || 0;
    if (price < 100) {
      return '';
    }
    if (price < 1000) {
      return 'size-100';
    }
    if (price < 10000) {
      return 'size-1000';
    }
    return 'size-10000';
  }, [coupon?.coupon_value]);
  const isInvalid = invalid || coupon?.user_coupon_state === 2;
  // useEffect(() => {}, []);

  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'event-coupon-item': true,
      invalid: isInvalid,
      [className || '']: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-coupon-item-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'event-coupon-item-left-price': true,
      [priceSize]: true
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "event-coupon-item-unit"
  }, "\xA5"), coupon?.formatValue), /*#__PURE__*/React.createElement("div", {
    className: "event-coupon-item-left-tag"
  }, "\u6307\u5B9A\u6D3B\u52A8\u5238")), /*#__PURE__*/React.createElement("div", {
    className: "event-coupon-item-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-coupon-item-right-dtl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hd"
  }, "\u6EE1", coupon?.formatThreshold, "\u5143\u53EF\u7528"), /*#__PURE__*/React.createElement("div", {
    className: "dtl"
  }, "\u6D3B\u52A8: ", coupon?.event_name), /*#__PURE__*/React.createElement("div", {
    className: "time"
  }, "\u6709\u6548\u671F: ", coupon?.timeRange)), checkType ? /*#__PURE__*/React.createElement(CheckType, {
    checked: coupon?.checked,
    onChange: onChange,
    disabled: isInvalid
  }) : /*#__PURE__*/React.createElement(CouponBtn, {
    onClick: onClick,
    disabled: isInvalid,
    coupon: coupon,
    goToUse: goToUse
  })));
};
export default /*#__PURE__*/memo(Coupon);